import { graphql } from "react-relay";

export const ChatsPageQuery = graphql`
  query ChatsPageQuery {
    me {
      ...appMe
      ...LlmConversationSidebar_me
      organization {
        uiTips {
          text
          url
          linkText
        }
      }
    }
  }
`;
